import classNames from '@/lib/classNames';

export default function LinkArrow({ className, strokeColor = 'primary', size = '45' }: { strokeColor?: string; size?: string; className?: string }) {
    return (
        <svg width={size} height={size} viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNames('group cursor-pointer overflow-hidden shrink-0', className)}>
            <circle cx="22.5" cy="22.5" r="21.5" stroke="currentColor" strokeWidth="2" className={`stroke-${strokeColor} transition group-hover:stroke-white group-hover:fill-white`} />
            <g id="arrow-hover" className="group-hover:animate-arrow-in">
                <path d="M11.4891 28.8566L33.5087 16.1436" stroke="currentColor" strokeWidth="2" className="group-hover:stroke-primary" />
                <path d="M23.3855 13.4311L33.5158 16.1455L30.8014 26.2759" stroke="currentColor" strokeWidth="2" className="group-hover:stroke-primary" />
            </g>
        </svg>
    );
}
